import * as tslib_1 from "tslib";
import { BaseComponent } from "../../../../base/base.component";
import { AppComponent } from "../../../../app.component";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { GenericService } from "../../../../../crossconcern/services/generic.services";
import { NurseryManager } from "../../../../../business/managers/nursery.manager";
import { AlertUtils } from "../../../../../crossconcern/utilities/utils/alert.utils";
import { PRIVATE_NURSERY_MAP_ROUTE } from "../../../../../crossconcern/utilities/properties/routename.property";
var SphereEditComponent = /** @class */ (function (_super) {
    tslib_1.__extends(SphereEditComponent, _super);
    function SphereEditComponent(appComponent, router, location, genericService, nurseryManager, activeRoute, alertUtils) {
        var _this = _super.call(this, appComponent, router, alertUtils, location) || this;
        _this.appComponent = appComponent;
        _this.router = router;
        _this.location = location;
        _this.genericService = genericService;
        _this.nurseryManager = nurseryManager;
        _this.activeRoute = activeRoute;
        _this.alertUtils = alertUtils;
        _this.nurseryUUID = "";
        _this.sphereUUID = "";
        return _this;
    }
    SphereEditComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.activeRoute.params.subscribe(function (params) {
            _this.nurseryUUID = params.id;
        });
        this.activeRoute.queryParams.subscribe(function (params) {
            _this.sphereUUID = params.start;
        });
        this.subscribeGenericServices();
    };
    SphereEditComponent.prototype.ngOnDestroy = function () {
        this.unsubscribeServices();
    };
    SphereEditComponent.prototype.subscribeGenericServices = function () {
        var _this = this;
        this.onGoBackCalledSubscription = this.genericService.onGoBackCalled.subscribe(function () {
            _this.goToRouteByName(PRIVATE_NURSERY_MAP_ROUTE, { id: _this.nurseryUUID });
        });
    };
    SphereEditComponent.prototype.unsubscribeServices = function () {
        if (this.onGoBackCalledSubscription) {
            this.onGoBackCalledSubscription.unsubscribe();
        }
    };
    return SphereEditComponent;
}(BaseComponent));
export { SphereEditComponent };
